const videoEl = document.querySelector('.summer-promo-festival-video');

if(videoEl) {
    const callback = (entries, observer) => {
        entries.forEach(entry => {
            const video = entry.target.querySelector('video');

            if (entry.isIntersecting) {
                video.play()
            } else {
                video.pause()
            }
        });
    };
    
    const options = {
        root: null, 
        rootMargin: "0px",
        threshold: 0.2 
    };
    
    const observer = new IntersectionObserver(callback, options);

    observer.observe(videoEl); 
}